define('adminLmbAnalyzerTabs',[
  'module',
  'underscore'
], function(
  module,
  _
) {
  'use strict';

  module.exports = [
    {
      name: 'detail',
      title: _.i18n('lmbanalyzers.details.tabTitle')
    }
  ];
});
